/* CheapFixIt — theme.js */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initDropdowns() {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(function (btn) {
      var wrap = btn.closest('.header__dropdown');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.header__dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
        var t = d.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initHeroCarousel() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      if (slides.length < 2) return;
      var idx = 0;
      var timer;
      function goTo(i) {
        idx = i;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }
      var interval = parseInt(hero.getAttribute('data-hero-interval'), 10) || 6;
      interval = Math.max(4, interval) * 1000;
      // Geen automatisch doorschuiven (besluit 2026-08-16): dia 1 is de
      // refurbished-boodschap en moet blijven staan; roterende hero's kosten
      // aantoonbaar kliks. Dia 2 en 3 blijven bereikbaar via de puntjes en vegen.
      // Zet AUTOPLAY op true om het oude gedrag terug te krijgen.
      var AUTOPLAY = false;
      function startTimer() {
        clearInterval(timer);
        if (!AUTOPLAY) return;
        timer = setInterval(function () {
          goTo((idx + 1) % slides.length);
        }, interval);
      }
      // Niet doorschuiven terwijl iemand de banner leest of de tab niet actief is
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', startTimer);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); } else { startTimer(); }
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
          startTimer();
        });
      });
      // Vegen tussen slides op touchschermen
      var startX = 0, startY = 0, swiping = false;
      hero.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? (idx + 1) % slides.length : (idx - 1 + slides.length) % slides.length);
          startTimer();
        }
      }, { passive: true });
      // Pas beginnen met wisselen als de pagina geladen is: een dia-wissel tijdens
      // het laden herstart Google's LCP-klok en maakt de gemeten laadtijd slechter.
      if (document.readyState === 'complete') {
        startTimer();
      } else {
        window.addEventListener('load', startTimer, { once: true });
      }
    });
  }

  function initScrollRows() {
    document.querySelectorAll('.scroll-row-wrap').forEach(function (wrap) {
      var row = wrap.querySelector('[data-scroll-row]');
      var next = wrap.querySelector('[data-scroll-next]');
      var prev = wrap.querySelector('[data-scroll-prev]');
      if (!row) return;
      function updateArrows() {
        var max = row.scrollWidth - row.clientWidth - 4;
        if (prev) prev.hidden = row.scrollLeft <= 4;
        if (next) next.hidden = row.scrollLeft >= max;
      }
      if (next) next.addEventListener('click', function () {
        row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
      });
      if (prev) prev.addEventListener('click', function () {
        row.scrollBy({ left: -row.clientWidth * 0.8, behavior: 'smooth' });
      });
      row.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function initSort() {
    document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
  }

  function initFacets() {
    document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-facet-group]');
        var closed = group.classList.toggle('is-closed');
        btn.setAttribute('aria-expanded', closed ? 'false' : 'true');
      });
    });
    document.querySelectorAll('[data-facet-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var values = btn.closest('.facet-group__body').querySelector('[data-facet-values]');
        values.classList.toggle('is-expanded');
        btn.textContent = values.classList.contains('is-expanded')
          ? btn.textContent.replace(/meer|more/i, function (m) { return m.toLowerCase() === 'meer' ? 'minder' : 'less'; })
          : btn.textContent.replace(/minder|less/i, function (m) { return m.toLowerCase() === 'minder' ? 'meer' : 'more'; });
      });
    });
    document.querySelectorAll('[data-facets-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input').forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    });
    /* Desktop: elke klik filtert direct. In het mobiele paneel (≤990px) blijft
       het paneel open, wordt de teller live ververst en past "Toon X
       producten" toe — zoals Coolblue. */
    var drawerMode = window.matchMedia('(max-width: 990px)');
    var foot = document.querySelector('[data-facets-foot]');
    var countEl = document.querySelector('[data-facets-count]');
    var applyBtn = document.querySelector('[data-facets-apply]');
    var facetsForm = document.querySelector('[data-facets-form]');
    var pending = null;

    function facetsUrl() {
      var fd = new FormData(facetsForm);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var url = new URL(window.location.pathname, window.location.origin);
      url.search = params.toString();
      return url;
    }

    function refreshCount() {
      if (!countEl || !facetsForm) return;
      var url = facetsUrl();
      var sectionId = facetsForm.closest('.shopify-section') ? facetsForm.closest('.shopify-section').id.replace('shopify-section-', '') : null;
      if (!sectionId) return;
      url.searchParams.set('section_id', sectionId);
      if (pending) pending.abort();
      pending = new AbortController();
      countEl.textContent = '…';
      fetch(url.toString(), { signal: pending.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tot = doc.querySelector('[data-facets-total]');
          if (tot) countEl.textContent = tot.textContent.trim();
        })
        .catch(function () {});
    }

    document.querySelectorAll('[data-facet-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var form = cb.closest('[data-facets-form]');
        if (!form) return;
        /* Sinds 17-9 (verzoek eigenaar) filtert ook mobiel direct bij een
           vinkje. Het paneel gaat na de herlaad automatisch weer open
           (vlaggetje hieronder), zodat je door kunt vinken. */
        if (drawerMode.matches && foot) {
          try { sessionStorage.setItem('filters-heropen', '1'); } catch (e) {}
        }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    if (facetsForm) {
      facetsForm.querySelectorAll('.facet-price__input').forEach(function (inp) {
        inp.addEventListener('change', function () { if (drawerMode.matches && foot) refreshCount(); });
      });
    }
    if (applyBtn && facetsForm) {
      applyBtn.addEventListener('click', function () {
        facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit();
      });
    }
  }

  function initViewToggle() {
    var toggle = document.querySelector('[data-view-toggle]');
    var results = document.querySelector('[data-collection-results]');
    if (!toggle || !results) return;
    // Producten staan maar één keer in de HTML; lijst/raster is puur CSS.
    // De beginweergave (bewaarde voorkeur, anders raster op telefoon) is al
    // door het inline script in main-collection.liquid gezet, dus hier wordt
    // die alleen uitgelezen - dat voorkomt layout shift.
    function setView(view, persist) {
      results.classList.toggle('collection__results--grid', view === 'grid');
      results.classList.toggle('collection__results--list', view === 'list');
      toggle.querySelectorAll('[data-view]').forEach(function (b) {
        var on = b.getAttribute('data-view') === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (persist) {
        try { localStorage.setItem('collection-view-v2', view); } catch (e) {}
      }
    }
    toggle.querySelectorAll('[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () { setView(btn.getAttribute('data-view'), true); });
    });
    // Knopstaat synchroon houden met de klasse die al op de container staat
    setView(results.classList.contains('collection__results--grid') ? 'grid' : 'list', false);
  }

  /* Bevestigingsvenster voor verwijderen uit de winkelwagen (native confirm
     oogt niet als de site en is op sommige telefoons uitgeschakeld). */
  function bevestigVerwijderen(titel, opJa) {
    var oud = document.querySelector('.cart-confirm');
    if (oud) oud.remove();
    var wrap = document.createElement('div');
    wrap.className = 'cart-confirm';
    wrap.innerHTML = '<div class="cart-confirm__backdrop"></div>' +
      '<div class="cart-confirm__box" role="dialog" aria-modal="true" aria-label="Product verwijderen">' +
      '<p class="cart-confirm__titel">Product verwijderen?</p>' +
      '<p class="cart-confirm__tekst"></p>' +
      '<div class="cart-confirm__knoppen">' +
      '<button type="button" class="cart-confirm__nee">Behouden</button>' +
      '<button type="button" class="cart-confirm__ja">Verwijderen</button>' +
      '</div></div>';
    wrap.querySelector('.cart-confirm__tekst').textContent = titel + ' staat op 1. Wil je het uit je winkelwagen halen?';
    document.body.appendChild(wrap);
    function sluit() { wrap.remove(); document.removeEventListener('keydown', opEsc); }
    function opEsc(e) { if (e.key === 'Escape') sluit(); }
    wrap.querySelector('.cart-confirm__backdrop').addEventListener('click', sluit);
    wrap.querySelector('.cart-confirm__nee').addEventListener('click', sluit);
    wrap.querySelector('.cart-confirm__ja').addEventListener('click', function () { sluit(); opJa(); });
    document.addEventListener('keydown', opEsc);
    wrap.querySelector('.cart-confirm__nee').focus();
  }

  function initSteppers() {
    document.querySelectorAll('[data-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      var minus = stepper.querySelector('[data-stepper-minus]');
      var plus = stepper.querySelector('[data-stepper-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        /* In de winkelwagen (data-cart-qty) mag het aantal naar 0, maar alleen
           na bevestiging: onder de 1 klikken betekent het product verwijderen. */
        if (input.hasAttribute('data-cart-qty') && v <= 1) {
          var rij = input.closest('tr');
          var titelEl = rij && rij.querySelector('.cart__item-title');
          bevestigVerwijderen(titelEl ? titelEl.textContent.trim() : 'dit product', function () {
            input.value = 0;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return;
        }
        var min = Math.max(1, parseInt(input.min, 10) || 1);
        if (v > min) input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('.pdp__main-track');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var current = 0;
    function goTo(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      current = i;
      if (track) track.style.transform = 'translateX(-' + i * 100 + '%)';
      thumbs.forEach(function (t) {
        var active = parseInt(t.getAttribute('data-gallery-thumb'), 10) === i;
        t.classList.toggle('is-active', active);
        if (active && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
      });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Vegen op touchschermen
    var media = gallery.querySelector('.pdp__main-media');
    if (media && slides.length > 1) {
      var startX = 0, startY = 0, swiping = false;
      media.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }
  }

  function initShare() {
    document.querySelectorAll('[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
        }
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      tabs.querySelectorAll('[data-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-tab');
          tabs.querySelectorAll('[data-tab]').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          tabs.querySelectorAll('[data-tab-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === name);
          });
        });
      });
    });
  }

  // Footerkolommen dichtklappen op telefoons; op grotere schermen blijven ze open
  function initFooterAccordion() {
    var folds = document.querySelectorAll('[data-footer-fold]');
    if (!folds.length) return;
    var mq = window.matchMedia('(max-width: 640px)');
    function apply() {
      folds.forEach(function (f) {
        if (mq.matches) { f.removeAttribute('open'); } else { f.setAttribute('open', ''); }
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  function initCollapse() {
    document.querySelectorAll('[data-collapse]').forEach(function (box) {
      var toggle = box.parentElement.querySelector('[data-collapse-toggle]');
      if (!toggle) return;
      var label = toggle.querySelector('[data-collapse-label]');
      if (!label) return;
      var cap = parseInt(box.getAttribute('data-collapse-scroll'), 10) || 0;
      var moreText = label.textContent;
      var active = false;
      var touched = false;

      // Meten bij DOMContentLoaded is niet betrouwbaar: webfonts en afbeeldingen
      // kunnen de hoogte daarna nog flink veranderen. Daarom opnieuw meten na
      // window.load, na het laden van de fonts en bij resize/rotatie - maar nooit
      // meer zodra de bezoeker de knop zelf heeft gebruikt.
      function measure() {
        if (touched) return;
        var tall = box.scrollHeight > 300;
        if (tall === active) return;
        active = tall;
        box.classList.toggle('is-collapsed', tall);
        toggle.hidden = !tall;
      }
      measure();
      window.addEventListener('load', measure);
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(measure).catch(function () {});
      }
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(measure, 150);
      });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          if (touched) { ro.disconnect(); return; }
          measure();
        });
        ro.observe(box);
      }

      toggle.addEventListener('click', function () {
        touched = true;
        var collapsed = box.classList.contains('is-collapsed');
        if (collapsed) {
          var target = cap ? Math.min(box.scrollHeight, cap) : box.scrollHeight;
          box.style.maxHeight = box.clientHeight + 'px';
          box.classList.remove('is-collapsed');
          if (cap && target <= box.clientHeight) {
            box.classList.add('is-scroll');
            box.style.maxHeight = target + 'px';
          } else {
            requestAnimationFrame(function () {
              box.style.maxHeight = target + 'px';
            });
            setTimeout(function () {
              if (cap) {
                box.classList.add('is-scroll');
                box.style.maxHeight = target + 'px';
              } else {
                box.style.maxHeight = '';
              }
            }, 400);
          }
        } else {
          box.style.maxHeight = box.clientHeight + 'px';
          box.classList.remove('is-scroll');
          box.scrollTop = 0;
          requestAnimationFrame(function () {
            box.classList.add('is-collapsed');
            box.style.maxHeight = '';
          });
        }
        collapsed = !collapsed;
        toggle.classList.toggle('is-open', !collapsed);
        label.textContent = collapsed ? moreText : moreText.replace(/meer|more/i, function (m) {
          return m.toLowerCase() === 'meer' ? 'minder' : 'less';
        });
      });
    });
  }

  function initSpecsSearch() {
    var input = document.querySelector('[data-specs-search]');
    if (!input) return;
    var wrap = input.closest('[data-specs]') || document;
    var groups = [].slice.call(wrap.querySelectorAll('[data-spec-group]'));
    var empty = wrap.querySelector('[data-specs-empty]');
    if (!groups.length) return;
    // Stand van de accordeon onthouden, zodat we die kunnen herstellen
    // zodra de zoekopdracht weer leeg is.
    var saved = null;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      if (q && !saved) {
        saved = groups.map(function (g) { return g.open === true; });
      }
      var hits = 0;
      groups.forEach(function (group, i) {
        var visible = 0;
        group.querySelectorAll('[data-spec-row]').forEach(function (row) {
          var hit = !q || row.textContent.toLowerCase().indexOf(q) !== -1;
          row.classList.toggle('is-hidden', !hit);
          if (hit) visible++;
        });
        group.classList.toggle('is-hidden', visible === 0);
        if (visible) hits++;
        if (q) {
          // Zoeken klapt groepen met een treffer automatisch open
          if (visible && 'open' in group) group.open = true;
        } else if (saved && 'open' in group) {
          group.open = saved[i];
        }
      });
      if (!q) saved = null;
      if (empty) empty.hidden = !(q && hits === 0);
    });
  }

  // "Alle specificaties" - klapt alle spec-groepen in een keer open of dicht
  function initSpecsExpand() {
    var btn = document.querySelector('[data-specs-expand]');
    if (!btn) return;
    var wrap = btn.closest('[data-specs]');
    if (!wrap) return;
    var groups = [].slice.call(wrap.querySelectorAll('[data-spec-group]'));
    var label = btn.querySelector('[data-specs-expand-label]');
    var openText = label ? label.textContent : '';
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      groups.forEach(function (g) { g.open = open; });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.classList.toggle('is-open', open);
      if (label) label.textContent = open ? 'Alles inklappen' : openText;
    });
  }

  function formatEuro(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    // Duizendtallen groeperen met een punt, net als Liquid's money-filter (1.299,-)
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s.slice(-3) === ',00' ? s.slice(0, -2) + '-' : s;
  }

  // Toont de gekozen variantspecs (RAM/opslag) achter de productnaam
  function initTitleConfig() {
    var el = document.querySelector('[data-title-config]');
    if (!el) return;
    var names;
    try { names = JSON.parse(el.getAttribute('data-option-names') || '[]'); } catch (e) { return; }
    var titleEl = el.parentElement;
    var baseTitle = titleEl ? (titleEl.textContent || '').replace(el.textContent, '').toUpperCase() : '';
    document.addEventListener('variant:changed', function (e) {
      var vr = e.detail && e.detail.variant;
      if (!vr) return;
      var vals = vr.options || [vr.option1, vr.option2, vr.option3];
      var out = '';
      names.forEach(function (n, i) {
        var val = vals[i];
        if (!val) return;
        if (baseTitle.indexOf(String(val).toUpperCase()) > -1) return;
        var k = String(n).toLowerCase();
        if (k.indexOf('geheugen') > -1 || k.indexOf('ram') > -1) {
          out += ' | ' + val + ' RAM';
        } else if (k.indexOf('opslag') > -1 || k.indexOf('ssd') > -1 || k.indexOf('schijf') > -1) {
          // Op een telefoonpagina is de opslag geen SSD; het achtervoegsel is
          // daar fout. De setje-container is de betrouwbare telefoonmarkering.
          out += ' | ' + val + (document.querySelector('[data-setje]') ? '' : ' SSD');
        } else {
          out += ' | ' + val;
        }
      });
      el.textContent = out;
    });
  }

  // Variantkiezer op de telefoonkaarten van de collectiepagina. Bewust los
  // van initVariantPicker(): die is met document.querySelector gebouwd voor
  // één kiezer per pagina (de productpagina), hier staan er veertien naast
  // elkaar en zoekt elke kaart binnen zichzelf.
  function initCardPickers() {
    // Op telefoonkaarten opent de winkelwagenknop de productpagina (met de
    // gekozen variant) in plaats van direct toe te voegen — zelfde gedrag als
    // op de kaart klikken. Alleen smartphones; laptops houden direct-toevoegen.
    // preventDefault is nodig omdat de knop een submit in het cart-formulier is.
    document.querySelectorAll('.product-card--phone').forEach(function (card) {
      var btn = card.querySelector('.product-card__cart-btn');
      var link = card.querySelector('.product-card__link');
      if (!btn || !link) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = link.getAttribute('href');
      });
    });

    document.querySelectorAll('.product-card--phone [data-card-picker]').forEach(function (picker) {
      var card = picker.closest('.product-card');
      if (!card) return;
      var dataEl = picker.querySelector('[data-card-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var link = card.querySelector('.product-card__link');
      var img = card.querySelector('.product-card__media img');
      // beide prijsblokken: het (verborgen) origineel in de link en het
      // zichtbare onder de kiezer — anders lopen ze uiteen bij een keuze
      var priceEls = card.querySelectorAll('.product-card__price .price');
      var idInput = card.querySelector('[data-card-variant-id]');
      var cartBtn = card.querySelector('.product-card__cart-btn');
      var badge = card.querySelector('.stock-badge');
      var baseUrl = link ? link.getAttribute('href').split('?')[0] : null;

      function selected() {
        var opts = [];
        picker.querySelectorAll('[data-pick].is-active').forEach(function (b) {
          opts[parseInt(b.getAttribute('data-option-pos'), 10) - 1] = b.getAttribute('data-value');
        });
        return opts;
      }

      function find(opts) {
        return variants.find(function (vr) {
          return (vr.o1 || null) === (opts[0] || null)
            && (vr.o2 || null) === (opts[1] || null)
            && (vr.o3 || null) === (opts[2] || null);
        });
      }

      // Grijs wat niet leverbaar is bij de huidige keuze van de ANDERE optie:
      // kies je 128 GB, dan vergrijzen de kleuren die alleen in 256 GB bestaan.
      // Grijs blokkeert niet — de klik hieronder laat de andere optie meebewegen
      // (de A36 heeft 256 GB alleen in paars; hard blokkeren maakte die variant
      // onbereikbaar). Grijs betekent dus "niet in deze combinatie", niet "weg".
      function markAvailability() {
        var current = selected();
        picker.querySelectorAll('[data-pick]').forEach(function (b) {
          var pos = parseInt(b.getAttribute('data-option-pos'), 10) - 1;
          var opts = current.slice();
          opts[pos] = b.getAttribute('data-value');
          var vr = find(opts);
          b.classList.toggle('is-unavailable', !vr || !vr.available);
        });
      }

      // Zoekt de beste variant met deze waarde: eerst met de overige keuzes
      // intact, anders de eerste leverbare die deze waarde heeft.
      function kies(pos, val) {
        var opts = selected();
        opts[pos] = val;
        var vr = find(opts);
        if (vr && vr.available) return vr;
        return variants.find(function (c) {
          return [c.o1, c.o2, c.o3][pos] === val && c.available;
        });
      }

      // Zet alle knoppen op de optiewaarden van deze variant
      function syncKnoppen(vr) {
        var waarden = [vr.o1, vr.o2, vr.o3];
        picker.querySelectorAll('[data-pick]').forEach(function (b) {
          var pos = parseInt(b.getAttribute('data-option-pos'), 10) - 1;
          b.classList.toggle('is-active', waarden[pos] === b.getAttribute('data-value'));
        });
      }

      function apply() {
        var vr = find(selected());
        if (!vr) return;
        priceEls.forEach(function (p) { p.textContent = formatEuro(vr.price); });
        if (idInput) idInput.value = vr.id;
        // srcset wint van src; zonder die te legen blijft de oude foto staan
        if (img && vr.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = vr.img; }
        if (link && baseUrl) link.setAttribute('href', baseUrl + '?variant=' + vr.id);
        if (cartBtn) cartBtn.disabled = !vr.available;
        if (badge) {
          badge.classList.toggle('stock-badge--in', vr.available);
          badge.classList.toggle('stock-badge--out', !vr.available);
          badge.textContent = vr.available ? badge.getAttribute('data-in-text') || 'Op voorraad' : 'Uitverkocht';
        }
        markAvailability();
      }

      picker.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function () {
          // Geen guard op is-unavailable: een vergrijsde waarde is wel te
          // kiezen, de andere optie springt dan mee. Bestaat de waarde nergens
          // leverbaar, dan vindt kies() niets en gebeurt er niets.
          var pos = parseInt(b.getAttribute('data-option-pos'), 10) - 1;
          var vr = kies(pos, b.getAttribute('data-value'));
          if (!vr) return;
          syncKnoppen(vr);
          apply();
        });
      });

      if (badge) badge.setAttribute('data-in-text', badge.textContent.trim());
      markAvailability();
    });
  }

  // Accessoireblok "jouw setje" op de smartphone-productpagina. Toestel plus
  // aangevinkte accessoires gaan in één keer het mandje in via /cart/add.js;
  // elk accessoire krijgt de property "Voor toestel" zodat de order eenduidig
  // is (de accessoire-producten zelf zijn generiek).
  function initPhoneSetje() {
    var blok = document.querySelector('[data-setje]');
    if (!blok) return;
    blok.removeAttribute('hidden');

    var totRij = blok.querySelector('[data-setje-stack]');
    var totEl = blok.querySelector('[data-setje-tot]');
    var subEl = blok.querySelector('[data-setje-sub]');
    var basis = totRij ? parseInt(totRij.getAttribute('data-base'), 10) || 0 : 0;

    function herteken() {
      var aan = [].slice.call(blok.querySelectorAll('[data-setje-item].is-aan'));
      var som = basis, delen = [];
      aan.forEach(function (b) {
        som += parseInt(b.getAttribute('data-prijs'), 10) || 0;
        var naam = b.getAttribute('data-naam');
        if (/^Klaphoes/.test(naam)) delen.push(naam.toLowerCase());
        else if (/glass/i.test(naam)) delen.push('glas');
        else if (/overzetten/i.test(naam)) delen.push('overzetten');
        else delen.push(naam.toLowerCase().split(' ')[0]);
      });
      if (totEl) totEl.textContent = '€ ' + formatEuro(som);
      // klaphoes gekozen? klap de grote voorvertoning open
      var hoesAan = blok.querySelector('[data-groep="hoes"].is-aan');
      var klap = blok.querySelector('[data-hoes-preview]');
      if (klap) {
        if (hoesAan && hoesAan.getAttribute('data-foto')) {
          klap.querySelector('[data-hoes-preview-img]').src = hoesAan.getAttribute('data-foto');
          klap.querySelector('[data-hoes-preview-naam]').textContent = hoesAan.getAttribute('data-naam') + ' · + € ' + formatEuro(parseInt(hoesAan.getAttribute('data-prijs'), 10));
          klap.hidden = false;
        } else { klap.hidden = true; }
      }
      // prijs kleurt mee met de selectie van zijn rij (grijs -> oranje)
      blok.querySelectorAll('.pdp-setje__regel').forEach(function (r) {
        r.classList.toggle('heeft-keuze', !!r.querySelector('[data-setje-item].is-aan'));
      });
      if (subEl) subEl.textContent = delen.length ? 'incl. ' + delen.join(' + ') : 'alleen het toestel';
    }

    blok.querySelectorAll('[data-setje-item]').forEach(function (b) {
      b.addEventListener('click', function () {
        var werdAan = !b.classList.contains('is-aan');
        // binnen een groep (klaphoes-kleuren) geldt: een tegelijk
        var groep = b.getAttribute('data-groep');
        if (groep && werdAan) {
          blok.querySelectorAll('[data-setje-item][data-groep="' + groep + '"]').forEach(function (o) {
            o.classList.remove('is-aan');
          });
        }
        b.classList.toggle('is-aan', werdAan);
        herteken();
      });
    });

    // basisprijs volgt de gekozen toestelvariant, en de galerij springt naar
    // de foto van die kleur (mapping uit data-variant-media)
    var mediaMap = null;
    var mediaEl = document.querySelector('[data-variant-media]');
    if (mediaEl) { try { mediaMap = JSON.parse(mediaEl.textContent); } catch (err) { mediaMap = null; } }
    document.addEventListener('variant:changed', function (e) {
      if (!e.detail || !e.detail.variant) return;
      basis = e.detail.variant.price;
      herteken();
      if (mediaMap && mediaMap[String(e.detail.variant.id)] !== undefined) {
        var idx = mediaMap[String(e.detail.variant.id)];
        // thumb-klik voor het scrollgedrag van de carrousel, en daarnaast de
        // is-active-klassen zelf zetten: dan werkt de wissel ook als de
        // carrousel zijn eigen administratie via scroll-events bijhoudt
        var thumb = document.querySelector('[data-gallery-thumb="' + idx + '"]');
        if (thumb) { thumb.click(); }
        document.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.getAttribute('data-gallery-slide'), 10) === idx);
        });
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-gallery-thumb'), 10) === idx);
        });
      }
    });

    // koopknop: met accessoires erbij alles in een POST naar het mandje
    var form = blok.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var aan = [].slice.call(blok.querySelectorAll('[data-setje-item].is-aan'));
        if (!aan.length) return;
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        var toestel = blok.getAttribute('data-toestel') || '';
        var items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
        aan.forEach(function (b) {
          items.push({ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1, properties: { 'Voor toestel': toestel } });
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(function (r) {
          if (!r.ok) throw new Error('cart: ' + r.status);
          window.location.href = '/cart';
        }).catch(function () {
          // val terug op het gewone formulier zodat het toestel er in elk geval in komt
          form.submit();
        });
      });
    }

    herteken();
  }


  function initVariantPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;
    var dataEl = picker.querySelector('[data-variant-data]');
    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var cartBtn = document.querySelector('.pdp__cart-btn');
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function selectedOptions() {
      var opts = [];
      picker.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
        opts[parseInt(r.getAttribute('data-option-pos'), 10) - 1] = r.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (vr) {
        return (vr.option1 || null) === (opts[0] || null)
          && (vr.option2 || null) === (opts[1] || null)
          && (vr.option3 || null) === (opts[2] || null);
      });
    }

    function updatePriceHints() {
      var current = selectedOptions();
      var base = findVariant(current);
      picker.querySelectorAll('input[type=radio]').forEach(function (r) {
        var pos = parseInt(r.getAttribute('data-option-pos'), 10) - 1;
        var opts = current.slice();
        opts[pos] = r.value;
        var vr = findVariant(opts);
        var hint = r.parentElement.querySelector('[data-option-price]');
        if (hint) {
          if (!vr || !base) {
            hint.textContent = '';
          } else if (r.checked || vr.price === base.price) {
            hint.textContent = formatEuro(vr.price);
            hint.classList.remove('option-card__price--delta');
          } else {
            var diff = vr.price - base.price;
            hint.textContent = (diff > 0 ? '+ ' : '− ') + formatEuro(Math.abs(diff));
            hint.classList.add('option-card__price--delta');
            hint.classList.toggle('option-card__price--save', diff < 0);
          }
        }
        r.parentElement.classList.toggle('option-card--unavailable', !vr || !vr.available);
      });
    }

    function updateLabels() {
      picker.querySelectorAll('.option-group').forEach(function (group) {
        var checked = group.querySelector('input[type=radio]:checked');
        var label = group.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    function apply() {
      var vr = findVariant(selectedOptions());
      if (!vr) {
        // Combinatie bestaat niet: knop op slot, anders bestelt de klant nog de
        // vorige variant terwijl er een andere is aangevinkt.
        if (cartBtn) cartBtn.disabled = true;
        updatePriceHints();
        updateLabels();
        return;
      }
      idInput.value = vr.id;
      if (priceEl) priceEl.textContent = formatEuro(vr.price);
      if (cartBtn) cartBtn.disabled = !vr.available;
      updatePriceHints();
      updateLabels();
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: vr } }));
    }

    picker.addEventListener('change', apply);
    updatePriceHints();
  }

  function flyToCart(fromEl) {
    var cartIcon = document.querySelector('.header__cart');
    if (!fromEl || !cartIcon) return;
    var from = fromEl.getBoundingClientRect();
    var to = cartIcon.getBoundingClientRect();
    var dot = document.createElement('span');
    dot.className = 'cart-fly';
    dot.style.left = (from.left + from.width / 2 - 10) + 'px';
    dot.style.top = (from.top + from.height / 2 - 10) + 'px';
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
        var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
        dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.25)';
        dot.style.opacity = '0.2';
      });
    });
    setTimeout(function () { dot.remove(); }, 800);
  }

  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      // Dubbelklikbeveiliging: loopt er al een verzoek voor dit formulier,
      // dan negeren we de tweede submit (anders dubbele add-ons).
      if (form.dataset.cartBusy === '1') return;
      form.dataset.cartBusy = '1';
      // Alle knoppen die dit formulier versturen, ook de sticky koopbalk
      // (die staat buiten de form en koppelt via form="...").
      var btns = [].slice.call(form.querySelectorAll('button[type=submit]'));
      if (form.id) {
        document.querySelectorAll('button[form="' + form.id + '"]').forEach(function (b) {
          if (btns.indexOf(b) === -1) btns.push(b);
        });
      }
      if (e.submitter && btns.indexOf(e.submitter) === -1) btns.push(e.submitter);
      var wasDisabled = btns.map(function (b) { return b.disabled; });
      btns.forEach(function (b) { b.disabled = true; });
      function releaseCartBtns() {
        form.dataset.cartBusy = '';
        btns.forEach(function (b, i) { b.disabled = wasDisabled[i]; });
      }
      // Onthouden of de POST zelf geslaagd is: faalt er daarna nog iets
      // (tellerupdate, een cart:added-listener), dan mag er geen tweede
      // gewone submit volgen - dat zou hetzelfde artikel nogmaals toevoegen.
      var posted = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); posted = true; return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.remove('is-bump');
            void el.offsetWidth;
            el.classList.add('is-bump');
          });
          if (btn) {
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 900);
          }
          flyToCart(btn);
          releaseCartBtns();
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { form: form } }));
        })
        .catch(function () {
          releaseCartBtns();
          if (!posted) form.submit();
        });
    });
  }

  function initCartAutoUpdate() {
    /* Aantal wijzigen ververst sinds aug 2026 niet meer de hele pagina. Hoe
       snel of vaak er ook geklikt wordt: alle wijzigingen worden kort verzameld
       en per gewijzigde regel één voor één via /cart/change.js verstuurd:
       die route bewaakt als enige de voorraad (/cart/update.js accepteerde in
       de test 6 stuks bij een voorraad van 1). Maximaal één verzoek tegelijk,
       dus geen race tussen regels en geen regen aan verzoeken richting de
       botbescherming. Er wordt nooit meer op een paginaherlaad teruggevallen;
       alleen een echt lege winkelwagen herlaadt om de lege staat te tonen. */
    function euro(cents) {
      return '€' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    var alleInputs = Array.prototype.slice.call(document.querySelectorAll('[data-cart-qty]'));
    var inputs = alleInputs.filter(function (i) { return i.getAttribute('data-line-key'); });
    /* Verouderde (gecachte) pagina zonder regelkenmerken: dan gewoon het
       formulier opsturen zoals vroeger, in plaats van rijen te raden. */
    alleInputs.filter(function (i) { return !i.getAttribute('data-line-key'); }).forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
    if (!inputs.length) return;
    var timer = null;
    var bezig = false;
    var laatst = {};
    inputs.forEach(function (input) {
      laatst[input.getAttribute('data-line-key')] = parseInt(input.value, 10) || 0;
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(verstuur, 350);
      });
    });
    function actueel() {
      return inputs.filter(function (i) { return document.body.contains(i); });
    }
    function melding(input, tekst) {
      var cel = input.closest('td') || input.closest('tr');
      if (!cel) return;
      var oud = cel.querySelector('.cart-qty-melding');
      if (oud) oud.remove();
      var el = document.createElement('div');
      el.className = 'cart-qty-melding';
      el.textContent = tekst;
      cel.appendChild(el);
      setTimeout(function () { el.remove(); }, 4000);
    }
    function toon(cart, gevraagd) {
      if (cart.item_count === 0) { window.location.reload(); return; }
      var uitDePas = false;
      actueel().forEach(function (input) {
        var key = input.getAttribute('data-line-key');
        var rij = input.closest('tr');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) {
          /* Een rij mag alleen verdwijnen als we zélf om verwijdering vroegen.
             Kent de server een andere regel niet (verouderde pagina, tweede
             tabblad), dan herladen we om weer gelijk te lopen; nooit zomaar
             rijen wissen terwijl de producten er nog zijn. */
          if (gevraagd && gevraagd[key] === 0) { if (rij) rij.remove(); delete laatst[key]; }
          else { uitDePas = true; }
          return;
        }
        laatst[key] = item.quantity;
        if (rij) rij.style.opacity = '';
        if (gevraagd && gevraagd[key] > item.quantity) {
          melding(input, 'Helaas, er is niet meer voorraad van dit product.');
        }
        /* Alleen terugzetten als er geen nieuwere klik openstaat voor deze regel. */
        if (gevraagd && key in gevraagd) input.value = item.quantity;
        var cel = document.querySelector('[data-line-total="' + key + '"]');
        if (cel) cel.textContent = euro(item.final_line_price);
      });
      var sub = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = euro(cart.items_subtotal_price);
      var tot = document.querySelector('[data-cart-total]');
      if (tot) tot.textContent = euro(cart.total_price);
      document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = cart.item_count; });
      if (uitDePas) window.location.reload();
    }
    function verstuur() {
      if (bezig) return;
      var input = actueel().find(function (i) {
        return (parseInt(i.value, 10) || 0) !== laatst[i.getAttribute('data-line-key')];
      });
      if (!input) return;
      bezig = true;
      var key = input.getAttribute('data-line-key');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      var rij = input.closest('tr');
      if (rij) rij.style.opacity = '0.6';
      var gevraagd = {};
      gevraagd[key] = qty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) {
        /* Weigert Shopify (voorraadgrens of tijdelijke drukte), haal dan de
           echte stand op en zet het aantal daarnaar terug. */
        if (r.ok) return r.json();
        return fetch('/cart.js').then(function (r2) {
          if (!r2.ok) throw new Error('cart ' + r2.status);
          return r2.json();
        });
      }).then(function (cart) {
        toon(cart, gevraagd);
      }).catch(function () {
        if (rij) rij.style.opacity = '';
        input.value = laatst[key] || 0;
        melding(input, 'Bijwerken is even niet gelukt. Controleer je verbinding en probeer het opnieuw.');
      }).then(function () {
        bezig = false;
        verstuur();
      });
    }
  }

  function initVisitForm() {
    var toggle = document.querySelector('[data-visit-toggle]');
    var wrap = document.querySelector('[data-visit-form]');
    if (!toggle || !wrap) return;
    var mapFrame = wrap.querySelector('iframe[data-map-src]');
    var mapBox = mapFrame ? mapFrame.closest('.store-visit__map') : null;

    function loadMap() {
      if (!mapFrame || mapFrame.getAttribute('src')) return;
      if (mapBox) mapBox.classList.add('is-zoomed');
      mapFrame.addEventListener('load', function () {
        setTimeout(function () {
          if (mapBox) mapBox.classList.remove('is-zoomed');
        }, 150);
      }, { once: true });
      mapFrame.src = mapFrame.getAttribute('data-map-src');
    }

    toggle.addEventListener('click', function () {
      wrap.hidden = !wrap.hidden;
      toggle.setAttribute('aria-expanded', wrap.hidden ? 'false' : 'true');
      if (!wrap.hidden) {
        loadMap();
        wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    if (!wrap.hidden) loadMap();
  }

  function initStickyTrust() {
    var bar = document.getElementById('stickyTrust');
    if (!bar) return;
    var threshold = 300;
    var ticking = false;
    function update() {
      var show = window.scrollY > threshold;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    if (!menu || !openBtn) return;
    function setOpen(open) {
      if (open) {
        menu.hidden = false;
        requestAnimationFrame(function () { menu.classList.add('is-open'); });
      } else {
        menu.classList.remove('is-open');
        setTimeout(function () { menu.hidden = true; }, 280);
      }
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openBtn.addEventListener('click', function () { setOpen(true); });
    menu.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) setOpen(false);
    });
  }

  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filters-drawer]');
    var openBtns = document.querySelectorAll('[data-filters-open]');
    if (!drawer || !openBtns.length) return;
    var backdrop = document.querySelector('.collection__sidebar-backdrop');
    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openBtns.forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    /* Kwam de bezoeker hier door een filtervinkje in het mobiele paneel, dan
       gaat het paneel meteen weer open om verder te filteren. */
    try {
      if (sessionStorage.getItem('filters-heropen') === '1') {
        sessionStorage.removeItem('filters-heropen');
        if (window.matchMedia('(max-width: 990px)').matches) setOpen(true);
      }
    } catch (e) {}
    document.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  /* Mobiele onderbalk: sorteersheet (Filters hergebruikt initFilterDrawer). */
  function initMobar() {
    var sheet = document.querySelector('[data-mobar-sort]');
    var openBtn = document.querySelector('[data-mobar-sort-open]');
    if (!sheet || !openBtn) return;
    function setOpen(open) {
      sheet.hidden = !open;
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    openBtn.addEventListener('click', function () { setOpen(true); });
    sheet.querySelectorAll('[data-mobar-sort-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    sheet.querySelectorAll('[data-mobar-sort-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', b.getAttribute('data-mobar-sort-value'));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) setOpen(false);
    });
  }

  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    var priceEl = bar.querySelector('[data-buybar-price]');
    var btn = bar.querySelector('[data-buybar-btn]');
    var buyRow = document.querySelector('.pdp__buy-row');

    document.addEventListener('variant:changed', function (e) {
      var vr = e.detail && e.detail.variant;
      if (!vr) return;
      if (priceEl) priceEl.textContent = formatEuro(vr.price);
      if (btn) btn.disabled = !vr.available;
    });

    if (buyRow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(buyRow);
    } else {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
  }

  /* Retour/garantie-wizard: native formulierpost, bevestiging na de redirect
     via sessionStorage (het ordernummer overleeft de reload niet in de DOM). */
  function initRetourWizard() {
    var root = document.querySelector('[data-rgw]');
    if (!root) return;
    var wizard = root.querySelector('[data-rgw-wizard]');
    var intro = root.querySelector('[data-rgw-intro]');
    var start = root.getAttribute('data-rgw-start') || 'keuze';

    function toonStap(naam) {
      wizard.querySelectorAll('[data-rgw-stap]').forEach(function (s) {
        s.hidden = s.getAttribute('data-rgw-stap') !== naam;
      });
      intro.hidden = true;
      wizard.hidden = false;
    }

    root.querySelectorAll('[data-rgw-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        toonStap(start === 'keuze' ? 'keuze' : start);
      });
    });
    root.querySelectorAll('[data-rgw-kies]').forEach(function (b) {
      b.addEventListener('click', function () { toonStap(b.getAttribute('data-rgw-kies')); });
    });
    root.querySelectorAll('[data-rgw-terug]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (start === 'keuze') { toonStap('keuze'); return; }
        wizard.hidden = true;
        intro.hidden = false;
      });
    });

    var defectVeld = root.querySelector('[data-rgw-defectveld]');
    root.querySelectorAll('[data-rgw-defect]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.classList.toggle('is-aan');
        if (!defectVeld) return;
        var aan = [];
        root.querySelectorAll('[data-rgw-defect].is-aan').forEach(function (d) {
          aan.push(d.getAttribute('data-rgw-defect'));
        });
        defectVeld.value = aan.join(', ');
      });
    });

    root.querySelectorAll('.rgw__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var type = form.querySelector('[name="contact[Type aanvraag]"]');
        var order = form.querySelector('[data-rgw-order]');
        try {
          sessionStorage.setItem('rgw', JSON.stringify({
            type: type ? type.value : '',
            order: order ? order.value : ''
          }));
        } catch (e) { /* privémodus: bevestiging valt terug op algemene tekst */ }
      });
    });

    /* Na de redirect kan de cache de posted-marker opeten; sessionStorage
       (gezet vlak voor het versturen) is daarom het primaire signaal. */
    var info = {};
    try { info = JSON.parse(sessionStorage.getItem('rgw') || '{}'); } catch (e) {}
    /* Link vanuit de paginatekst (#retour-garantie of #garantie / #retour):
       wizard meteen openen in de juiste stroom. */
    function openViaHash() {
      var hash = (window.location.hash || '').replace('#', '');
      if (hash !== 'retour-garantie' && hash !== 'garantie' && hash !== 'retour') return;
      toonStap(hash === 'retour-garantie' ? (start === 'keuze' ? 'keuze' : start) : hash);
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    openViaHash();
    /* Link op dezelfde pagina (bijv. "garantieformulier" in de tekst): geen
       herlaad, alleen een hash-wissel — dus ook daarop reageren. */
    window.addEventListener('hashchange', openViaHash);
    if (root.querySelector('[data-rgw-posted]') || info.type) {
      var echo = root.querySelector('[data-rgw-order-echo]');
      var orderRegel = root.querySelector('[data-rgw-order-regel]');
      if (echo && info.order) {
        echo.textContent = info.order;
        if (orderRegel) orderRegel.hidden = false;
      }
      toonStap(info.type === 'Retour' ? 'klaar-retour' : 'klaar-garantie');
      try { sessionStorage.removeItem('rgw'); } catch (e) {}
      root.scrollIntoView({ block: 'start' });
    }
  }

  ready(function () {
    initStickyTrust();
    initVisitForm();
    initAjaxCart();
    initCartAutoUpdate();
    initDropdowns();
    initHeroCarousel();
    initScrollRows();
    initSort();
    initFacets();
    initViewToggle();
    initSteppers();
    initGallery();
    initShare();
    initTabs();
    initCollapse();
    initSpecsSearch();
    initSpecsExpand();
    initVariantPicker();
    initPhoneSetje();
    initCardPickers();
    initTitleConfig();
    initMobileMenu();
    initFooterAccordion();
    initFilterDrawer();
    initMobar();
    initBuyBar();
    initRetourWizard();
  });
})();
